export default __webpack_public_path__ + "static/media/error.62138228.png";